import universityThemes from '../university-themes';

export default {
	setup() {
		const universityTheme = universityThemes['su'];
		return { universityTheme };
	},
	computed: {
		themes() {
			return universityThemes;
		},
	},

	mounted() {
		const { hostname } = location;
		const subdomain = hostname.split('.').reverse().slice(3).join('.');
		if (this.themes.hasOwnProperty(subdomain)) {
			this.universityTheme = this.themes[subdomain];

			this.$store.dispatch('updateUniversityTheme', this.universityTheme)
				.catch(error => {
					console.error('Error updating university theme:', error);
				});

			let variables = document.querySelector(':root');

			variables.style.setProperty(
				'--primary',
				this.universityTheme.primary,
			);
			variables.style.setProperty(
				'--secondary',
				this.universityTheme.secondary,
			);
			variables.style.setProperty(
				'--primary-dark',
				this.universityTheme.primaryDark,
			);

			//Navbar
			if (this.universityTheme.navbar) {
				variables.style.setProperty(
					'--navbar',
					this.universityTheme.navbar,
				);
			}

			if (this.universityTheme.navbarDark) {
				variables.style.setProperty(
					'--navbar-dark',
					this.universityTheme.navbarDark,
				);
			}

			if (this.universityTheme.navbarText) {
				variables.style.setProperty(
					'--navbar-text',
					this.universityTheme.navbarText,
				);
			}
			if (this.universityTheme.navbarTextDark) {
				variables.style.setProperty(
					'--navbar-text-dark',
					this.universityTheme.navbarTextDark,
				);
			}
			if (this.universityTheme.navbarTextActive) {
				variables.style.setProperty(
					'--navbar-text-active',
					this.universityTheme.navbarTextActive,
				);
			}
			if (this.universityTheme.navbarTextActiveDark) {
				variables.style.setProperty(
					'--navbar-text-active-dark',
					this.universityTheme.navbarTextActiveDark,
				);
			}

			//Job Card
			if (this.universityTheme.jobCardBanner) {
				variables.style.setProperty(
					'--job-card-banner',
					this.universityTheme.jobCardBanner,
				);
			}

			if (this.universityTheme.jobCardBannerDark) {
				variables.style.setProperty(
					'--job-card-banner-dark',
					this.universityTheme.jobCardBannerDark,
				);
			}

			if (this.universityTheme.jobCardBannerActive) {
				variables.style.setProperty(
					'--job-card-banner-active',
					this.universityTheme.jobCardBannerActive,
				);
			}

			if (this.universityTheme.jobCardBannerActiveDark) {
				variables.style.setProperty(
					'--job-card-banner-active-dark',
					this.universityTheme.jobCardBannerActiveDark,
				);
			}

			if (this.universityTheme.jobCardBannerText) {
				variables.style.setProperty(
					'--job-card-banner-text',
					this.universityTheme.jobCardBannerText,
				);
			}

			if (this.universityTheme.jobCardBannerTextDark) {
				variables.style.setProperty(
					'--job-card-banner-text-dark',
					this.universityTheme.jobCardBannerTextDark,
				);
			}

			//Apply Button
			if (this.universityTheme.applyButton) {
				variables.style.setProperty(
					'--apply-button',
					this.universityTheme.applyButton,
				);
			}
			if (this.universityTheme.applyButtonDark) {
				variables.style.setProperty(
					'--apply-button-dark',
					this.universityTheme.applyButtonDark,
				);
			}
			if (this.universityTheme.applyButtonText) {
				variables.style.setProperty(
					'--apply-button-text',
					this.universityTheme.applyButtonText,
				);
			}
			if (this.universityTheme.applyButtonTextDark) {
				variables.style.setProperty(
					'--apply-button-text-dark',
					this.universityTheme.applyButtonTextDark,
				);
			}
		}
	},
};
